import React, { useEffect, useRef } from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function LoginMessageDialog(props) {
  const { title, message, okCallback } = props;

  const okButtonRef = useRef(null);
  const focusAttemptedRef = useRef(false);

  useEffect(() => {
    const okEl = okButtonRef.current;
    if (!okEl) return;

    // Only attempt once on mount
    if (!focusAttemptedRef.current) {
      focusAttemptedRef.current = true;
      okEl.focus();
    }

    // If something steals focus after mount, re-assert ONCE.
    // This avoids repeated announcements.
    const t = setTimeout(() => {
      const stillExists = okButtonRef.current;
      if (!stillExists) return;

      // Only refocus if focus is NOT already inside the dialog's OK button
      if (document.activeElement !== stillExists) {
        stillExists.focus();
      }
    }, 50);

    return () => clearTimeout(t);
  }, []);

  return (
    <Dialog
      className="hide-dialog-close"
      title={title}
      onClose={okCallback}
      autoFocusedElement="#login-message-ok"
    >
      <p
        tabIndex={-1}
        style={{ margin: "25px", whiteSpace: "pre-line" }}
      >
        {message}
      </p>

      <DialogActionsBar>
        <button
          id="login-message-ok"
          ref={okButtonRef}
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          onClick={okCallback}
          type="button"
        >
          OK
        </button>
      </DialogActionsBar>
    </Dialog>
  );
}
